import { render, staticRenderFns } from "./group-post-details.vue?vue&type=template&id=0b260cef"
import script from "./group-post-details.vue?vue&type=script&lang=js"
export * from "./group-post-details.vue?vue&type=script&lang=js"
import style0 from "./group-post-details.vue?vue&type=style&index=0&id=0b260cef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports